import blickComp from '../components/blick-comp.vue'
import CoolFeaturesSlider from '../includes/CoolFeaturesSlider.js'
export default {
  name: 'project-mobile',
  components: {
    blickComp,
    CoolFeaturesSlider
  },
  data(){
    return {
    }
  },
  mounted(){
    this.$root.$data.showBlick$
      .filter(data=> data.to == 'mobile-window')
      .throttleTime(5000)
      .subscribe(data=>{
        // console.log('here')
        this.$refs.blick.animate();
      })
  }
}



// WEBPACK FOOTER //
// ./src/includes/ProjectMobile.js